import { render, staticRenderFns } from "./alunos.vue?vue&type=template&id=b1bc9b72"
import script from "./alunos.vue?vue&type=script&lang=js"
export * from "./alunos.vue?vue&type=script&lang=js"
import style0 from "./alunos.vue?vue&type=style&index=0&id=b1bc9b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports